import PlayersPage from "@/pages/players/page";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_pathlessLayout/players")({
    validateSearch: z.object({
        teamId: z.coerce.number().optional(),
    }),
    component: PlayersPage,
});
